import {
  baseContractAddresses,
  ethereumContractAddresses,
  externalBaseContractAddresses,
} from '../data';

export const baseDelegatedContractAddresses = [
  baseContractAddresses.wearable.toLowerCase(),
  baseContractAddresses.pass.toLowerCase(),
  externalBaseContractAddresses.doodlesCertifiedViral.toLowerCase(),
];

export const ethereumDelegatedContractAddresses = [
  ethereumContractAddresses.doodles.toLowerCase(),
  ethereumContractAddresses.spaceDoodles.toLowerCase(),
  ethereumContractAddresses.dooplicator.toLowerCase(),
  ethereumContractAddresses.genesisBox.toLowerCase(),
];
